<div class="form-field">
  <div class="maps-container" *ngIf="mapValues?.length">
    <label>Map Values Present</label>
    <div
      class="map-container"
      *ngFor="let mapValue of mapValues; let i = index"
    >
      <p class="map-container-content">
        <span
          >Replace "{{ mapValue?.fromValue }}" to "{{ mapValue?.toValue }}"</span
        >
      </p>
      <button (click)="removeMap(i)" pButton class="map-delete-btn">
        Delete
      </button>
    </div>
  </div>

  <label>Add Map Logic</label>

  <input
    placeholder="From Value"
    pInputText
    fluid
    style="padding: 0.4375rem 1rem; margin-left: 3px"
    [(ngModel)]="fromValue"
  />

  <input
    placeholder="To Value"
    pInputText
    fluid
    style="padding: 0.4375rem 1rem; margin-left: 3px"
    [(ngModel)]="toValue"
  />

  <button
  [disabled]="!fromValue && !toValue"
    pButton
    severity="primary"
    (click)="addMap()"
  >
    Add Map Logic
  </button>
</div>
